export default __webpack_public_path__ + "static/media/naan.efeb2dac.jpg";